
import * as THREE from 'three';
import { ThreeView } from '../../view3d/webcad/View3dWebCad';
import { CreateObject } from '../CreateObject';
import { PointInfo } from '../WalltoFittingInfo';

export class Draw3d {

    constructor() {
        
    }

    // ランダムでカラーを取得
    static getColor(): THREE.Color {
        const color = (Math.random() * 0xFFFFFF | 0).toString(16);
        const randomColor = "#" + ("000000" + color).slice(-6);
        return new THREE.Color(randomColor);
    }

    // matrixからxyz方向ベクトルを抽出して表示
    static lineCreate(matrix: number[]): void {
        const x = new THREE.Vector3(matrix[0], matrix[1], matrix[2]);
        const y = new THREE.Vector3(matrix[4], matrix[5], matrix[6]);
        const z = new THREE.Vector3(matrix[8], matrix[9], matrix[10]);
        const offset = new THREE.Vector3(matrix[12], matrix[13], matrix[14]);
        this.drawArrowHelper(x, offset, 0xFF0000);
        this.drawArrowHelper(y, offset, 0x00FF00);
        this.drawArrowHelper(z, offset, 0x0000FF);
    }

    // ArrowHelperを表示
    static drawArrowHelper(origin: THREE.Vector3, dir: THREE.Vector3, color: THREE.ColorRepresentation): void {
        const helper = new THREE.ArrowHelper(dir, origin, dir.length(), color);
        ThreeView.get().wcItemmgr.addLiDARShapes(helper);
    }

    // グリッドを表示
    static drawGrid(box: THREE.Box3, unit: number) {
        
        const length = (box.max.z - box.min.z) / unit;
        console.log(length);        
        for (let i = 0; i < length + 1; i++) {
            // x軸
            const minX = new THREE.Vector3(box.min.x, box.min.y, box.min.z + unit * i);
            const maxX = new THREE.Vector3(box.max.x + unit, box.min.y, box.min.z + unit * i);
            const object = CreateObject.createLine([minX, maxX], new THREE.Color('#00ced1'));
            ThreeView.get().wcItemmgr.addLiDARShapes(object);
        }

        const length_ = (box.max.x - box.min.x) / unit;
        console.log(length_);
        for (let j = 0; j < length_ + 1; j++) {
            // y軸(2D上での)
            const minY = new THREE.Vector3(box.min.x + unit * j, box.min.y, box.min.z);
            const maxY = new THREE.Vector3(box.min.x + unit * j, box.min.y, box.max.z + unit);
            const object = CreateObject.createLine([minY, maxY], new THREE.Color('#00ced1'));
            ThreeView.get().wcItemmgr.addLiDARShapes(object);
        }

    }
    
    // ベクトルを表示
    static draw(dir: THREE.Vector3, origin: THREE.Vector3) {
        const helper = new THREE.ArrowHelper(dir, origin, dir.length());
        ThreeView.get().wcItemmgr.addLiDARShapes(helper);
    }

    // 外壁表示
    static outerWall(pointList: PointInfo[], list: number[]) {
        list.forEach((value: number, index: number, array: number[]) => {
            const next = array[(index+1) % array.length];
            const dir = pointList[next].point.clone().sub(pointList[value].point);
            const helper = new THREE.ArrowHelper(dir, pointList[value].point, dir.length(), new THREE.Color(0xFFD700));
            ThreeView.get().wcItemmgr.addLiDARShapes(helper);
        });
    }
    
    // pointListから壁を表示
    static view(pointList: PointInfo[], color: THREE.Color = new THREE.Color('#d3d3d3')) {
        for (let i = 0; i < pointList.length; i+=2) {
            if (pointList[i].isDelete) continue;
            const p1 = pointList[i].point.clone();
            const p2 = pointList[i + 1].point.clone();
            const dir = p2.clone().sub(p1);
            const center = dir.clone().divideScalar(2);
            const width = dir.clone().length();
            const height = 1;
            const depth = 0.01; // 奥行きは取得できないため決め打ち
            const mesh = CreateObject.createBoxGrometry(width, height, depth, color);
            const pos = center.clone().add(p1);
            mesh.position.set(pos.x, 0, pos.z);
            const rad = dir.clone().angleTo(new THREE.Vector3(1, 0, 0));
            mesh.rotateOnAxis(new THREE.Vector3(0, 1, 0), rad);
            mesh.userData.index = i;
            ThreeView.get().wcItemmgr.addLiDARShapes(mesh);
        }
    }

    
}